export default __webpack_public_path__ + "../images/al-a-logo.png";